import { render } from "./qxc-q4.vue?vue&type=template&id=20a01911&scoped=true"
import script from "./qxc-q4.vue?vue&type=script&lang=js"
export * from "./qxc-q4.vue?vue&type=script&lang=js"

import "./qxc-q4.vue?vue&type=style&index=0&id=20a01911&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a01911"]])

export default __exports__